import React, {
    useEffect,
    useState,
  } from "react";
  
  import {
    useLocation,
    useNavigate,
  } from "react-router-dom";
  
  import {
    collection,
    getDocs,
    addDoc,
    serverTimestamp,
  } from "firebase/firestore";
  
  import { db } from "../firebase";
  
  import "./OtherCountryConfirmed.css";
  
  
  // =====================================================
  // MINIMUM DEPOSIT KWA KILA NCHI
  // =====================================================
  
  const countryMinAmounts = {
  
    Kenya: 927.64,
  
    Uganda: 25974.02,
  
    Rwanda: 10526.36,
  
    Burundi: 21276.6,
  
    "DR Congo": 7.24,
  
    "DRC - Congo": 7.24,
  
    Zambia: 135.84,
  
    Malawi: 14468.8,
  
    Mozambique: 457.56,
  
    Zimbabwe: 7.24,
  
    "South Sudan": 42553.2,
  
    Botswana: 94.36,
  
    Madagascar: 29198,
  
  };
  
  
  // =====================================================
  // CURRENCY KWA KILA NCHI
  // =====================================================
  
  const countryCurrency = {
  
    Kenya: "KES",
  
    Uganda: "UGX",
  
    Rwanda: "RWF",
  
    Burundi: "BIF",
  
    "DR Congo": "CDF",
  
    "DRC - Congo": "USD",
  
    Zambia: "ZMW",
  
    Malawi: "MWK",
  
    Mozambique: "MZN",
  
    Zimbabwe: "USD",
  
    "South Sudan": "SSP",
  
    Botswana: "BWP",
  
    Madagascar: "MGA",
  
  };
  
  
  // =====================================================
  // DEPOSIT INSTRUCTIONS
  // =====================================================
  
  const countryMethods = {
  
    Kenya: [
      {
        network: "Safaricom or Airtel",
        ussd: "*840#",
        steps: [
          "Select (1) Send Money To Abroad",
          "Select (1) Send to Mobile Number",
          "Select (3) Send to Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below in international format",
          "Enter the exact deposit amount shown below in KES",
          "Select (2) Business or Investment",
          "Select (1) Confirm and enter Your PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    Uganda: [
      {
        network: "Airtel or MTN",
        ussd: "*165#",
        steps: [
          "Select Send Money",
          "Select International Transfer",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in UGX",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    Rwanda: [
      {
        network: "Airtel or MTN",
        ussd: "*182#",
        steps: [
          "Select Send Money",
          "Select International Transfer",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in RWF",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    Burundi: [
      {
        network: "Ecocash or Lumicash",
        ussd: "",
        steps: [
          "Dial Ecocash or Lumicash USSD",
          "Select International Transfer",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in BIF",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    "DRC - Congo": [
      {
        network:
          "Vodacom M-Pesa / Airtel / Orange / Illico Cash",
        ussd: "",
        steps: [
          "Dial your mobile money USSD",
          "Select Send Money",
          "Select International",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in USD",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    "DR Congo": [
      {
        network:
          "Vodacom M-Pesa / Airtel / Orange / Illico Cash",
        ussd: "",
        steps: [
          "Dial your mobile money USSD",
          "Select Send Money",
          "Select International",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in CDF",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    Zambia: [
      {
        network: "Airtel / MTN / Zamtel",
        ussd: "*115#",
        steps: [
          "Select Send Money",
          "Select Cross Border",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in ZMW",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    Malawi: [
      {
        network: "Airtel / TNM",
        ussd: "*211#",
        steps: [
          "Select International Transfer",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in MWK",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    Mozambique: [
      {
        network: "Vodacom",
        ussd: "",
        steps: [
          "Dial M-Pesa USSD",
          "Select Send Money",
          "Select International Transfer",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in MZN",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    Zimbabwe: [
      {
        network: "EcoCash",
        ussd: "*151#",
        steps: [
          "Select Send Money",
          "Select International Transfer",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in USD",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    "South Sudan": [
      {
        network: "MGurush / MTN",
        ussd: "",
        steps: [
          "Select International Transfer",
          "Select Tanzania",
          "Enter recipient mobile number shown below",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter the exact deposit amount shown below in SSP",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    Botswana: [
      {
        network: "Orange / BTC / Mascom",
        ussd: "",
        steps: [
          "Select International Transfer",
          "Select Tanzania",
          "Enter recipient mobile number shown below",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter the exact deposit amount shown below in BWP",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    Madagascar: [
      {
        network: "Airtel / Orange",
        ussd: "",
        steps: [
          "Select International Transfer",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in MGA",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  };
  
  
  // =====================================================
  // COMPONENT
  // =====================================================
  
  const OtherCountryConfirmed = () => {
  
    const location = useLocation();
  
    const navigate = useNavigate();
  
  
    // ===================================================
    // DEPOSIT DATA
    // ===================================================
  
    const deposit =
      location.state?.deposit || null;
  
  
    // ===================================================
    // USERNAME
    // ===================================================
  
    const storedUsername =
      localStorage.getItem("username") ||
      "Guest";
  
    const [username] =
      useState(storedUsername);
  
  
    // ===================================================
    // FORM
    // ===================================================
  
    const [phone, setPhone] =
      useState("");
  
    const [transactionId, setTransactionId] =
      useState("");
  
  
    // ===================================================
    // FIREBASE RECEIVING ACCOUNT
    // ===================================================
  
    const [orbitaInfo, setOrbitaInfo] =
      useState({
  
        account: "",
  
        name: "",
  
      });
  
  
    // ===================================================
    // LOADING
    // ===================================================
  
    const [loadingOrbita, setLoadingOrbita] =
      useState(true);
  
    const [submitting, setSubmitting] =
      useState(false);
  
  
    // ===================================================
    // ERROR
    // ===================================================
  
    const [errorMessage, setErrorMessage] =
      useState("");
  
  
    // ===================================================
    // SUCCESS
    // ===================================================
  
    const [successMessage, setSuccessMessage] =
      useState("");
  
  
    // ===================================================
    // CONFIRMATION POPUP
    // ===================================================
  
    const [showConfirmation, setShowConfirmation] =
      useState(false);
  
  
    // ===================================================
    // COUNTRY
    // ===================================================
  
    const countryName =
      deposit?.countryName ||
      deposit?.country?.name ||
      "";
  
  
    // ===================================================
    // FLAG
    // ===================================================
  
    const flag =
      deposit?.flag ||
      deposit?.country?.flag ||
      "";
  
  
    // ===================================================
    // CURRENCY
    // ===================================================
  
    const currency =
      deposit?.currency ||
      deposit?.country?.currency ||
      countryCurrency[countryName] ||
      "";
  
  
    // ===================================================
    // AMOUNT
    // ===================================================
  
    const amount =
      Number(deposit?.amount) || 0;
  
  
    // ===================================================
    // MINIMUM
    // ===================================================
  
    const minimumAmount =
      Number(
        deposit?.minimumAmount ||
        countryMinAmounts[countryName] ||
        0
      );
  
  
    // ===================================================
    // RATE
    // ===================================================
  
    const rate =
      Number(deposit?.rate) || 0;
  
  
    // ===================================================
    // RECEIVE AMOUNT
    // ===================================================
  
    const receiveAmount =
      Number(deposit?.receiveAmount) || 0;
  
  
    // ===================================================
    // PAYMENT METHOD
    // ===================================================
  
    const paymentMethod =
      deposit?.paymentMethod || "";
  
  
    // ===================================================
    // RECEIVE CURRENCY
    // ===================================================
  
    const receiveCurrency =
      deposit?.receiveCurrency || "USDT";
  
  
    // ===================================================
    // METHODS
    // ===================================================
  
    const methods =
      countryMethods[countryName] || [];
  
  
    // ===================================================
    // SELECTED METHOD
    // ===================================================
  
    const selectedMethod =
      methods.find((method) => {
  
        if (!paymentMethod) {
          return false;
        }
  
        return method.network
          .toLowerCase()
          .includes(
            paymentMethod.toLowerCase()
          );
  
      }) ||
  
      methods[0] ||
  
      null;
  
  
    // ===================================================
    // FORMAT NUMBER
    // ===================================================
  
    const formatAmount = (value) => {
  
      if (
        value === null ||
        value === undefined ||
        Number(value) === 0
      ) {
  
        return "0";
  
      }
  
      return Number(value)
        .toLocaleString(
          undefined,
          {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          }
        );
  
    };
  
  
    // ===================================================
    // FORMAT RECEIVING NUMBER
    // ===================================================
  
    const formatReceivingNumber = (rawNumber) => {
  
      if (
        rawNumber === undefined ||
        rawNumber === null
      ) {
  
        return "";
  
      }
  
  
      let number =
        rawNumber
          .toString()
          .trim();
  
  
      if (!number) {
        return "";
      }
  
  
      // REMOVE SPACES
  
      number =
        number.replace(
          /\s+/g,
          ""
        );
  
  
      // 0XXXXXXXXX -> 255XXXXXXXXX
  
      if (
        number.startsWith("0")
      ) {
  
        return number.replace(
          /^0/,
          "255"
        );
  
      }
  
  
      // +255XXXXXXXX -> 255XXXXXXXX
  
      if (
        number.startsWith("+255")
      ) {
  
        return number.replace(
          /^\+255/,
          "255"
        );
  
      }
  
  
      // ALREADY 255
  
      if (
        number.startsWith("255")
      ) {
  
        return number;
  
      }
  
  
      return number;
  
    };
  
  
    // ===================================================
    // FETCH RANDOM RECEIVING ACCOUNT
    // ===================================================
  
    const fetchRandomOrbita = async () => {
  
      try {
  
        setLoadingOrbita(true);
  
        setErrorMessage("");
  
  
        const snapshot =
          await getDocs(
            collection(
              db,
              "othercountry"
            )
          );
  
  
        if (
          snapshot.empty
        ) {
  
          setErrorMessage(
            "No receiving account is available at the moment."
          );
  
  
          setOrbitaInfo({
  
            account: "",
  
            name: "",
  
          });
  
  
          return;
  
        }
  
  
        const docs =
          snapshot.docs;
  
  
        const randomDoc =
          docs[
            Math.floor(
              Math.random() *
              docs.length
            )
          ].data();
  
  
        const account =
          formatReceivingNumber(
            randomDoc.number
          );
  
  
        setOrbitaInfo({
  
          account:
            account,
  
          name:
            randomDoc.name ||
            "",
  
        });
  
      }
  
      catch (error) {
  
        console.error(
          "Firebase error:",
          error
        );
  
  
        setErrorMessage(
          "Failed to load receiving account."
        );
  
      }
  
      finally {
  
        setLoadingOrbita(false);
  
      }
  
    };
  
  
    // ===================================================
    // LOAD PAGE
    // ===================================================
  
    useEffect(() => {
  
      if (!deposit) {
  
        navigate(
          "/deposit-express",
          {
            replace: true,
          }
        );
  
        return;
  
      }
  
  
      if (
        amount <
        minimumAmount
      ) {
  
        setErrorMessage(
          `Minimum deposit is ${formatAmount(
            minimumAmount
          )} ${currency}.`
        );
  
        return;
  
      }
  
  
      if (
        !paymentMethod
      ) {
  
        setErrorMessage(
          "Payment network was not selected."
        );
  
        return;
  
      }
  
  
      fetchRandomOrbita();
  
    }, [
      deposit,
      amount,
      minimumAmount,
      currency,
      paymentMethod,
      navigate,
    ]);
  
  
    // ===================================================
    // COPY TEXT
    // ===================================================
  
    const copyText = async (text) => {
  
      if (!text) {
        return;
      }
  
  
      try {
  
        if (
          navigator.clipboard &&
          window.isSecureContext
        ) {
  
          await navigator.clipboard
            .writeText(text);
  
          alert(
            "Copied: " + text
          );
  
          return;
  
        }
  
  
        const textarea =
          document.createElement(
            "textarea"
          );
  
  
        textarea.value =
          text;
  
  
        textarea.style.position =
          "fixed";
  
  
        textarea.style.left =
          "-999999px";
  
  
        textarea.style.top =
          "-999999px";
  
  
        document.body.appendChild(
          textarea
        );
  
  
        textarea.focus();
  
        textarea.select();
  
  
        document.execCommand(
          "copy"
        );
  
  
        textarea.remove();
  
  
        alert(
          "Copied: " + text
        );
  
      }
  
      catch (error) {
  
        console.error(
          "Copy error:",
          error
        );
  
  
        alert(
          "Copy failed"
        );
  
      }
  
    };
  
  
    // ===================================================
    // HANDLE I HAVE DEPOSITED
    // ===================================================
  
    const handleIHaveDeposited = () => {
  
      setErrorMessage("");
  
      setSuccessMessage("");
  
  
      // PHONE
  
      if (
        !phone.trim()
      ) {
  
        setErrorMessage(
          "Please enter your deposit number first."
        );
  
        return;
  
      }
  
  
      // TRANSACTION ID
  
      if (
        !transactionId.trim()
      ) {
  
        setErrorMessage(
          "Please enter your Transaction ID / Message first."
        );
  
        return;
  
      }
  
  
      // RECEIVING ACCOUNT
  
      if (
        !orbitaInfo.account
      ) {
  
        setErrorMessage(
          "Receiving account is not ready."
        );
  
        return;
  
      }
  
  
      // OPEN CONFIRMATION
  
      setShowConfirmation(true);
  
    };
  
  
    // ===================================================
    // FINAL CONFIRMATION
    // ===================================================
  
    const handleFinalConfirm =
      async () => {
  
        setErrorMessage("");
  
        setSuccessMessage("");
  
  
        try {
  
          setSubmitting(true);
  
  
          // =============================================
          // SAVE TO FIREBASE
          // =============================================
  
          await addDoc(
            collection(
              db,
              "visterdeposte"
            ),
            {
  
              username:
                username.trim(),
  
              country:
                countryName,
  
              flag:
                flag,
  
              currency:
                currency,
  
              customerPhone:
                phone.trim(),
  
              orbitaPhone:
                orbitaInfo.account,
  
              orbitaName:
                orbitaInfo.name,
  
              amount:
                amount,
  
              minimumAmount:
                minimumAmount,
  
              rate:
                rate,
  
              receiveAmount:
                receiveAmount,
  
              receiveCurrency:
                receiveCurrency,
  
              paymentMethod:
                paymentMethod,
  
              transactionId:
                transactionId.trim(),
  
              excludeVerification:
                deposit?.excludeVerification ||
                false,
  
              status:
                "processing",
  
              createdAt:
                serverTimestamp(),
  
            }
          );
  
  
          // =============================================
          // CLOSE POPUP
          // =============================================
  
          setShowConfirmation(false);
  
  
          // =============================================
          // SUCCESS
          // =============================================
  
          setSuccessMessage(
            "Deposit submitted successfully. Your deposit is now being processed."
          );
  
  
          // =============================================
          // CLEAR INPUTS
          // =============================================
  
          setPhone("");
  
          setTransactionId("");
  
        }
  
        catch (error) {
  
          console.error(
            "Deposit error:",
            error
          );
  
  
          setErrorMessage(
            "Failed to submit deposit request. Please try again."
          );
  
        }
  
        finally {
  
          setSubmitting(false);
  
        }
  
      };
  
  
    // ===================================================
    // NO DEPOSIT DATA
    // ===================================================
  
    if (!deposit) {
  
      return null;
  
    }
  
  
    // ===================================================
    // RETURN
    // ===================================================
  
    return (
  
      <div className="other-country-container">
  
  
        {/* =================================================
            BACK BUTTON
        ================================================= */}
  
        <button
          type="button"
          className="back-btn"
          onClick={() =>
            navigate(-1)
          }
        >
  
          ⬅️ Back
  
        </button>
  
  
        {/* =================================================
            SEND PAYMENT TO
            ONLY ONCE
        ================================================= */}
  
        <div className="receiving-card">
  
          <h3>
            Send Payment To
          </h3>
  
  
          {/* RECIPIENT NUMBER */}
  
          <div className="account-row">
  
            <div>
  
              <span>
                Recipient Number
              </span>
  
  
              <strong>
  
                {loadingOrbita
  
                  ? "Loading..."
  
                  : orbitaInfo.account ||
                    "Unavailable"}
  
              </strong>
  
            </div>
  
  
            {orbitaInfo.account && (
  
              <button
                type="button"
                onClick={() =>
                  copyText(
                    orbitaInfo.account
                  )
                }
              >
  
                Copy
  
              </button>
  
            )}
  
          </div>
  
  
          {/* ACCOUNT NAME */}
  
          <div className="account-row">
  
            <div>
  
              <span>
                Account Name
              </span>
  
  
              <strong>
  
                {loadingOrbita
  
                  ? "Loading..."
  
                  : orbitaInfo.name ||
                    "Unavailable"}
  
              </strong>
  
            </div>
  
  
            {orbitaInfo.name && (
  
              <button
                type="button"
                onClick={() =>
                  copyText(
                    orbitaInfo.name
                  )
                }
              >
  
                Copy
  
              </button>
  
            )}
  
          </div>
  
        </div>
  
  
        {/* =================================================
            HOW TO DEPOSIT
        ================================================= */}
  
        <div className="instructions-card">
  
  
          {/* HEADER */}
  
          <div className="instructions-header">
  
            <div>
  
              <h3>
                How to Deposit
              </h3>
  
  
              <span>
                {paymentMethod}
              </span>
  
            </div>
  
          </div>
  
  
          {/* =================================================
              USSD
          ================================================= */}
  
          {selectedMethod?.ussd && (
  
            <div className="ussd-box">
  
              <span>
                USSD
              </span>
  
  
              <strong>
                {selectedMethod.ussd}
              </strong>
  
            </div>
  
          )}
  
  
          {/* =================================================
              STEPS
          ================================================= */}
  
          <ol className="deposit-steps">
  
            {selectedMethod?.steps?.map(
              (step, index) => {
  
                let instruction =
                  step;
  
  
                // -----------------------------------------
                // REPLACE 255X PLACEHOLDER
                // -----------------------------------------
  
                if (
                  /255X+/i.test(
                    instruction
                  )
                ) {
  
                  instruction =
                    instruction.replace(
                      /255X+/gi,
                      orbitaInfo.account ||
                      "Loading recipient number..."
                    );
  
                }
  
  
                // -----------------------------------------
                // IDENTIFY RECIPIENT STEP
                // -----------------------------------------
  
                const isRecipientStep =
                  /recipient.*mobile|mobile number|recipient number|enter number/i
                    .test(
                      instruction
                    );
  
  
                // -----------------------------------------
                // ADD ACTUAL RECIPIENT
                // -----------------------------------------
  
                if (
                  isRecipientStep &&
                  orbitaInfo.account &&
                  !instruction.includes(
                    orbitaInfo.account
                  )
                ) {
  
                  instruction =
                    `${instruction} — Recipient: ${orbitaInfo.account};`
  
                }
  
  
                return (
  
                  <li
                    key={index}
                  >
  
                    <span className="step-number">
  
                      {index + 1}
  
                    </span>
  
  
                    <span className="step-text">
  
                      {instruction}
  
                    </span>
  
                  </li>
  
                );
  
              }
            )}
  
          </ol>
  
        </div>
  
  
        {/* =================================================
            USER DEPOSIT NUMBER
        ================================================= */}
  
        <div className="input-box">
  
          <label>
            Enter Your Deposit Number
          </label>
  
  
          <input
            type="tel"
            inputMode="tel"
            placeholder="Enter your mobile number"
            value={phone}
            onChange={(e) =>
              setPhone(
                e.target.value
              )
            }
          />
  
        </div>
  
  
        {/* =================================================
            DEPOSIT AMOUNT
        ================================================= */}
  
        <div className="input-box">
  
          <label>
            Deposit Amount
          </label>
  
  
          <input
            type="text"
            value={`${formatAmount(
              amount
            )} ${currency}`}
            readOnly
          />
  
        </div>
  
  
        {/* =================================================
            TRANSACTION ID
        ================================================= */}
  
        <div className="input-box">
  
          <label>
            Transaction ID / Message
          </label>
  
  
          <input
            type="text"
            placeholder="Example: DCQ..... / PP276......."
            value={transactionId}
            onChange={(e) =>
              setTransactionId(
                e.target.value
              )
            }
          />
  
        </div>
  
  
        {/* =================================================
            ERROR
        ================================================= */}
  
        {errorMessage && (
  
          <div className="form-error">
  
            {errorMessage}
  
          </div>
  
        )}
  
  
        {/* =================================================
            SUCCESS
        ================================================= */}
  
        {successMessage && (
  
          <div className="form-success">
  
            {successMessage}
  
          </div>
  
        )}
  
  
        {/* =================================================
            I HAVE DEPOSITED
        ================================================= */}
  
        <button
          type="button"
          className="deposit-btn"
          onClick={
            handleIHaveDeposited
          }
          disabled={
            submitting ||
            loadingOrbita
          }
        >
  
          I Have Deposited
  
        </button>
  
  
        {/* =================================================
            FINAL CONFIRMATION POPUP
        ================================================= */}
  
        {showConfirmation && (
  
          <div
            className="confirmation-overlay"
            onClick={() => {
  
              if (!submitting) {
  
                setShowConfirmation(
                  false
                );
  
              }
  
            }}
          >
  
  
            <div
              className="confirmation-modal"
              onClick={(e) =>
                e.stopPropagation()
              }
            >
  
  
              {/* =========================================
                  HEADER
              ========================================== */}
  
              <div className="confirmation-header">
  
                <div className="confirmation-icon">
  
                  ✓
  
                </div>
  
  
                <h2>
                  Confirm Deposit
                </h2>
  
  
                <p>
  
                  Please check your deposit details
                  before submitting.
  
                </p>
  
              </div>
  
  
              {/* =========================================
                  HISTORY / SUMMARY
              ========================================== */}
  
              <div className="confirmation-history">
  
  
                {/* COUNTRY */}
  
                <div className="history-row">
  
                  <span>
                    Country
                  </span>
  
  
                  <strong>
  
                    {flag}{" "}
  
                    {countryName}
  
                  </strong>
  
                </div>
  
  
                {/* AMOUNT */}
  
                <div className="history-row">
  
                  <span>
                    Deposit Amount
                  </span>
  
  
                  <strong>
  
                    {formatAmount(
                      amount
                    )}{" "}
  
                    {currency}
  
                  </strong>
  
                </div>
  
  
                {/* RECEIVE */}
  
                <div className="history-row">
  
                  <span>
                    You Receive
                  </span>
  
  
                  <strong>
  
                    {receiveAmount.toFixed(2)}
  
                    {" "}
  
                    {receiveCurrency}
  
                  </strong>
  
                </div>
  
  
                {/* PAYMENT NETWORK */}
  
                <div className="history-row">
  
                  <span>
                    Payment Network
                  </span>
  
  
                  <strong>
  
                    {paymentMethod}
  
                  </strong>
  
                </div>
  
  
                {/* DEPOSIT NUMBER */}
  
                <div className="history-row">
  
                  <span>
                    Deposit Number
                  </span>
  
  
                  <strong>
  
                    {phone}
  
                  </strong>
  
                </div>
  
  
                {/* TRANSACTION ID */}
  
                <div className="history-row">
  
                  <span>
                    Transaction ID
                  </span>
  
  
                  <strong>
  
                    {transactionId}
  
                  </strong>
  
                </div>
  
  
                {/* RECEIVING ACCOUNT */}
  
                <div className="history-row">
  
                  <span>
                    Receiving Account
                  </span>
  
  
                  <strong>
  
                    {orbitaInfo.account}
  
                  </strong>
  
                </div>
  
  
                {/* ACCOUNT NAME */}
  
                {orbitaInfo.name && (
  
                  <div className="history-row">
  
                    <span>
                      Account Name
                    </span>
  
  
                    <strong>
  
                      {orbitaInfo.name}
  
                    </strong>
  
                  </div>
  
                )}
  
  
                {/* STATUS */}
  
                <div className="history-row">
  
                  <span>
                    Status
                  </span>
  
  
                  <strong className="processing">
  
                    Processing
  
                  </strong>
  
                </div>
  
              </div>
  
  
              {/* =========================================
                  ACTIONS
              ========================================== */}
  
              <div className="confirmation-actions">
  
  
                <button
                  type="button"
                  className="cancel-confirmation"
                  onClick={() =>
                    setShowConfirmation(
                      false
                    )
                  }
                  disabled={
                    submitting
                  }
                >
  
                  Cancel
  
                </button>
  
  
                <button
                  type="button"
                  className="confirm-confirmation"
                  onClick={
                    handleFinalConfirm
                  }
                  disabled={
                    submitting
                  }
                >
  
                  {submitting
  
                    ? "Submitting..."
  
                    : "Confirm Deposit"}
  
                </button>
  
              </div>
  
            </div>
  
          </div>
  
        )}
  
      </div>
  
    );
  
  };
  
  
  export default OtherCountryConfirmed;